export default __webpack_public_path__ + "static/media/IncredibleAnimalsCamouflage_01.f0869479.png";